export default __webpack_public_path__ + "static/media/404-error-page-2952323-2451625.3a230ce9.png";